import { getCountryConfig } from '@fluxora/country-config';

export const country = getCountryConfig('US');
